import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { useParams } from "react-router-dom";
//
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { FirestoreContextProvider } from "./components/firebase/FirestoreContext";
//
import Login from "./components/screens/Login";
import MainLayout from "./components/screens/MainLayout";
// Brands
import Brands from "./components/screens/Brands";
import NewBrand from "./components/screens/Brands/NewBrand";
import EditBrand from "./components/screens/Brands/EditBrand";

import Media from "./components/screens/Media";

// Products
import Products from "./components/screens/Products";
import NewProduct from "./components/screens/Products/NewProduct";
import EditProduct from "./components/screens/Products/EditProduct";
import UploadCSVProduct from "./components/screens/Products/UploadCSVProduct";
import ProductCategories from "./components/screens/ProductCategories";
import ProductVibes from "./components/screens/ProductVibes";
import ListProducts from "./components/screens/Products/ListProducts";

// Knowledge & FAQ
import Knowledge from "./components/screens/Knowledge";
import EditKnowledge from "./components/screens/Knowledge/EditKnowledge";

import FAQ from "./components/screens/Faq";

// Modals
import Modals from "./components/screens/Modals";
import NewModal from "./components/screens/Modals/NewModal";
import EditModal from "./components/screens/Modals/EditModal";

// Categories
import Categories from "./components/screens/Categories";
import ProductTags from "./components/screens/ProductTags";

// Stores
import Stores from "./components/screens/Stores";
import NewStore from "./components/screens/Stores/NewStore";
import EditStores from "./components/screens/Stores/EditStore";
import NewUsersLimit from "./components/screens/NewUsersLimit";

// Listings
import Listings from "./components/screens/Listings";
import EditListings from "./components/screens/Listings/EditListings";
import SooperDeals from "./components/screens/Listings/SooperDeals";
import Featured from "./components/screens/Listings/Featured";

// DosingGuide

import DosingGuide from "./components/screens/DosingGuide";
import EditDosingGuide from "./components/screens/DosingGuide/EditDosingGuide";
import NewDosingGuide from "./components/screens/DosingGuide/NewDosingGuide";

// Newsletter
import NewsletterSubscribers from "./components/screens/Newsletter/NewsletterSubscribers";

// Marketing
import MarketingProduct from "./components/screens/Marketing/MarketingProduct";
import DiscountCodes from "./components/screens/Marketing/DiscountCodes";
import ReferralSystem from "./components/screens/Marketing/ReferralSystem";
import ProductRequest from "./components/screens/Marketing/ProductRequest";

import CartLogs from "./components/screens/Logs/CartLogs";

// Messages
import MessagingMail from "./components/screens/Messaging/MessagingMail";

// Users
import Users from "./components/screens/Users";
import EditUser from "./components/screens/Users/EditUser";

// Shipping Options
import ShippingOptions from "./components/screens/ShippingOptions";
import ShippingOptionsList from "./components/screens/ShippingOptions/ShippingOptionsList";
import NewShippingOption from "./components/screens/ShippingOptions/NewShippingOption";
import EditShippingOption from "./components/screens/ShippingOptions/EditShippingOption";

//
import Shipment from "./components/screens/Shipment";
import WalletSettings from "./components/screens/WalletSettings";
import ShipmentCompliance from "./components/screens/Shipment/ShipmentCompliance";

// Orders
import Orders from "./components/screens/Orders";

// Venmo
import VenmoPendingPayments from "./components/screens/Venmo/VenmoPendingPayments";

import NotFound from "./components/screens/404";

// Admins
import Admins from "./components/screens/Admins";

// Legal
import LegalTerms from "./components/screens/Legal/LegalTerms";
import LegalPrivacy from "./components/screens/Legal/LegalPrivacy";
import LegalFDA from "./components/screens/Legal/LegalFDA";

//
import PaymentGateways from "./components/screens/PaymentGateways";
import EditFAQ from "./components/screens/FAQ/EditFAQ";

//
import AboutUs from "./components/screens/Pages/AboutUs";
import HelpCenter from "./components/screens/Pages/HelpCenter";
import Support from "./components/screens/Pages/Support";

//
import InitialReviews from "./components/screens/InitialReviews";
import { UserContextProvider, useUser } from "./components/context/UserContext";
import { useContext } from "react";

// Firestore config
const firebaseConfig = {
  apiKey: "AIzaSyC_CSwQUSpnV4M-tH1m31PBwfbIE6cHhd8",
  authDomain: "fullproof-app.firebaseapp.com",
  projectId: "fullproof-app",
  storageBucket: "fullproof-app.firebasestorage.app",
  messagingSenderId: "700451320996",
  appId: "1:700451320996:web:2e95136981e1cb35462231",
  measurementId: "G-J4BKYMQ8HX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const functions = getFunctions(app);

if (process.env.REACT_APP_EMULATE_DB === "true") {
  connectFirestoreEmulator(db, "localhost", 8080);
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("Connected to Firebase emulators");
}

const App = () => {
  return (
    <FirestoreContextProvider db={db} functions={functions}>
      <UserContextProvider>
        <Router>
          <AppRoutes />
        </Router>
      </UserContextProvider>
    </FirestoreContextProvider>
  );
};

const ProtectedRoutes = ({ children }) => {
  const { adminData } = useUser();
  return <Routes children={children} />;
};
// Separate component for routes, to use useEnvironment inside Router
const AppRoutes = () => {
  const { adminData, user, loading } = useUser();
  const params = useParams();
  console.log({ user, adminData });

  if (loading) return null;

  if (!adminData) {
    return (
      <Routes>
        <Route path={`/`} element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path={`/`} element={<Login />} />
      <Route path={`/main`} element={<MainLayout />}>
        <Route path="brands" element={<Brands />}>
          <Route path="new" element={<NewBrand />} />
          <Route path="edit" element={<EditBrand />} />
          <Route path="edit/:id" element={<EditBrand />} />
        </Route>
        <Route path="media" element={<Media />} />
        <Route path="products" element={<Products />}>
          <Route index element={<ListProducts />} />
          <Route path="new" element={<NewProduct />} />
          <Route path="edit" element={<EditProduct />} />
          <Route path="edit/:id" element={<EditProduct />} />
          <Route path="uploadcsv" element={<UploadCSVProduct />} />
        </Route>
        <Route path="product_categories" element={<ProductCategories />} />
        <Route path="product_vibes" element={<ProductVibes />} />
        <Route path="modals" element={<Modals />}>
          <Route path="new" element={<NewModal />} />
          <Route path="edit/:id" element={<EditModal />} />
        </Route>

        <Route path="about_us" element={<AboutUs />} />

        <Route path="help_center" element={<HelpCenter />} />

        <Route path="support" element={<Support />} />

        <Route path="listings" element={<Listings />}>
          <Route path="edit/:id" element={<EditListings />} />
          <Route path="sooper-deals/:id" element={<SooperDeals />} />
        </Route>
        <Route path="featured" element={<Featured />} />
        <Route path="orders" element={<Orders />}>
          <Route path=":seller_id" element={<Orders />}>
            <Route path=":id" element={<Orders />} />
          </Route>
        </Route>
        <Route path="knowledge" element={<Knowledge />}>
          <Route path="edit/:id" element={<EditKnowledge key={params.id} />} />

          <Route path="new" element={<EditKnowledge />} />
        </Route>
        <Route path="faq" element={<FAQ />}>
          <Route path="edit/:id" element={<EditFAQ />} />
          <Route path="new" element={<EditFAQ />} />
        </Route>

        <Route path="stores" element={<Stores />}>
          <Route path="new" element={<NewStore />} />
          <Route path="edit" element={<EditStores />} />
          <Route path="edit/:id" element={<EditStores />} />
        </Route>
        <Route path="dosingGuide" element={<DosingGuide />}>
          <Route path="new" element={<NewDosingGuide />} />
          <Route path="edit" element={<EditDosingGuide />} />
          <Route path="edit/:id" element={<EditDosingGuide />} />
        </Route>
        <Route path="discount_codes" element={<DiscountCodes />} />

        <Route path="categories" element={<Categories />} />
        <Route path="product_tags" element={<ProductTags />} />

        <Route path="initial_reviews" element={<InitialReviews />} />

        <Route path="shipping-options" element={<ShippingOptions />}>
          <Route index element={<ShippingOptionsList />} />
          <Route path="new" element={<NewShippingOption />} />
          <Route path="edit/:id" element={<EditShippingOption />} />
        </Route>

        <Route path="shipment" element={<Shipment />} />
        <Route path="shipment_compliance" element={<ShipmentCompliance />} />
        <Route path="wallet_settings" element={<WalletSettings />} />
        <Route path="NewUsersLimit" element={<NewUsersLimit />} />
        <Route
          path="venmo_pending_payments"
          element={<VenmoPendingPayments />}
        />
        <Route
          path="newsletter_subscribers"
          element={<NewsletterSubscribers />}
        />
        <Route path="marketing_product" element={<MarketingProduct />} />
        <Route path="referral_system" element={<ReferralSystem />} />
        <Route path="product_request" element={<ProductRequest />} />
        <Route path="users" element={<Users />} />
        <Route path="users/edit/:id" element={<EditUser />} />
        <Route path="admins" element={<Admins />} />
        <Route path="payment_gateways" element={<PaymentGateways />} />
        <Route path="messaging_mail" element={<MessagingMail />} />
        <Route path="cart_logs" element={<CartLogs />} />
        <Route path="legal_terms" element={<LegalTerms />} />
        <Route path="legal_privacy" element={<LegalPrivacy />} />
        <Route path="legal_fda" element={<LegalFDA />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
